/* eslint-disable max-len */
/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import './new-transfer.scss';
import React, {
    Component,
} from 'react';
import MeasurementReading from '../../shared/state/measurement-reading';
import Modal from '../../../../sharedmodules/state/modal';
import NewTransferBody from './new-transfer-body';
import NewTransferHeader from './new-transfer-header';
import Product from '../../shared/state/product';
import PropTypes from 'prop-types';
import Transfer from '../state/transfer';
import WarrantyLoadingIndicator from '../../shared/components/warranty-loading-indicator';
import { isCommentValid } from './comment-validation';

function handleCancelClick(actions) {

    actions.goToPreviousView();

}

function handleCreateTransferClick(prop) {

    prop.actions.createTransfer(prop.auth.getAccessToken);

}

function handleGoToDealerSearchClick(actions, dealerSearchModal) {

    actions.updateDealerSearchModalVisibility(dealerSearchModal.isVisible);

}

function handleAccountLookupChange(account, actions) {

    actions.updateAccountLookup(account);

}

function handleAccountLookupBlur(account, prop) {

    prop.actions.readDealer(prop.auth.getAccessToken, account);

}

function handleReasonForTransferInputChange(event, newTransfer, actions) {

    if (isCommentValid(newTransfer.reasonForChange, event.target.value)) {

        actions.updateReasonForChange(event.target.value);

    }

}

function handleResetTransferClick(actions) {

    actions.updateAccountLookup('');
    actions.resetNewTransfer();

}

function handleStatusChangeModalVisibility(value, actions) {

    actions.updateNewTransferStatusChangeModal('isVisible', value);

}

function handleAmountOfUseModalClose(actions) {

    actions.updateAmountOfUseModalVisibility(false);

}

function handleAmountOfUseModalOpen(actions) {

    actions.updateAmountOfUseModalVisibility(true);

}

function handleUpdateStatus(actions) {

    actions.updateNewTransferStatusChangeModal('isVisible', false);

}

class NewTransfer extends Component {

    componentWillMount() {

        this.props.actions.resetAccountLookup();
        this.props.actions.resetNewTransfer();
        this.props.actions.updateAccountLookup('');
        this.props.actions.updateProduct(this.props.auth.getAccessToken, this.props.pin);

    }

    componentWillUnmount() {

        this.props.actions.resetProductDetails();
        this.props.actions.resetLatestPerUnitMeasurements();
        this.props.actions.updateAmountOfUseModalVisibility(false);

    }

    render() {

        return (
            <section className="new-transfer">
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0} />
                <main>
                    <NewTransferHeader
                        changeModalVisibility={(e) => handleStatusChangeModalVisibility(e.target.value, this.props.actions)}
                        isAmountOfUseModalOpen={this.props.isAmountOfUseModalOpen}
                        measurementReadings={this.props.measurementReadings}
                        onAmountOfUseModalClose={() => handleAmountOfUseModalClose(this.props.actions)}
                        onAmountOfUseModalOpen={() => handleAmountOfUseModalOpen(this.props.actions)}
                        product={this.props.product}
                        productStatusChangeModal={this.props.newTransferStatusChangeModal}
                        updateStatus={() => handleUpdateStatus(this.props.actions)}
                    />
                    <NewTransferBody
                        actions={this.props.actions}
                        accountLookup={this.props.accountLookup}
                        dealer={this.props.product.dealer}
                        dealerSearchModal={this.props.dealerSearchModal}
                        newTransfer={this.props.newTransfer}
                        onAccountLookupBlur={(e) => handleAccountLookupBlur(e, this.props)}
                        onAccountLookupChange={(e) => handleAccountLookupChange(e, this.props.actions)}
                        onCancelClick={() => handleCancelClick(this.props.actions)}
                        onCreateTransferClick={() => handleCreateTransferClick(this.props)}
                        onDealerSearchViewClick={() => handleGoToDealerSearchClick(this.props.actions, this.props.dealerSearchModal)}
                        onReasonForChangeInputChange={(e) => handleReasonForTransferInputChange(e, this.props.newTransfer, this.props.actions)}
                        onResetClick={() => handleResetTransferClick(this.props.actions)}

                    />
                </main>
            </section>
        );

    }

}

NewTransfer.displayName = 'NewTransfer';
NewTransfer.propTypes = {
    accountLookup: PropTypes.string.isRequired,
    actions: PropTypes.object,
    auth: PropTypes.object.isRequired,
    busyCounter: PropTypes.bool.isRequired,
    dealerSearchModal: PropTypes.instanceOf(Modal).isRequired,
    handleReset: PropTypes.func,
    isAmountOfUseModalOpen: PropTypes.bool.isRequired,
    measurementReadings: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    newTransfer: PropTypes.instanceOf(Transfer).isRequired,
    newTransferStatusChangeModal: PropTypes.instanceOf(Modal).isRequired,
    pin: PropTypes.string.isRequired,
    product: PropTypes.instanceOf(Product).isRequired,
};

export default NewTransfer;
